/**
 * 后端 API 基础地址（全仓唯一真源）
 *
 * 生产镜像把 VITE_API_BASE_URL 构建为 "/"（nginx 反代 /api/* 到后端）。
 * 若直接字符串拼接 `${base}/api/xxx`，会得到 "//api/xxx" —— 浏览器按协议相对
 * URL 解析成 https://api/xxx，请求打到名为 "api" 的主机上，报
 * net::ERR_NAME_NOT_RESOLVED（表现为 token 刷新、文件上传、SSE 流式全部失败）。
 * 因此统一在此处去掉尾部斜杠，凡手动拼接 URL 的地方都从这里取值。
 */
export const API_BASE_URL = (
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080'
).replace(/\/+$/, '')
